import React, { useEffect, useRef, useState } from "react";
import "./SearchComponent.scss";
import { Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  CalendarIcon,
  ErrorIcon,
  // LocationIcon,
} from "../../../../../common/IconList/IconList";
import userImg from "../../../../../common/images/user.svg";
// import locationImg from "../../../../../common/images/location.svg";
import { Calendar } from "react-date-range";
import moment from "moment";
import PassengerSelection from "../../../PassengerSelection";
import { isMobile } from "../../../../../utils/util";
import BottomSearchSheet from "./BottomSearchSheet/BottomSearchSheet";
import BottomSearchSheetForList from "./BottomSearchSheetForList/BottomSearchSheetForList";

const SearchComponent = (props) => {
  const {
    state,
    disableCity = false,
    showOnlyCity = false,
    hideCity = false,
  } = props;

  const [openPassenger, setOpenPassenger] = useState(false);
  const [openCheckin, setOpenCheckin] = useState(false);
  const [openCheckout, setOpenCheckout] = useState(false);
  const [showSearchSheet, setShowSearchSheet] = useState("");
  const [showBottomSheet, setShowBottomSheet] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenCheckin(false);
        setOpenCheckout(false);
        setOpenPassenger(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOpenSheet = (val) => {
    if (isMobile) {
      if (showOnlyCity) {
        setShowBottomSheet(true);
        return;
      }
      setShowSearchSheet(val);
    }
  };

  return (
    <>
      <div className="stay-search-main">
        <div className="stay-search-main__title">Search hotels & stays</div>
        <div className="stay-search-main__fields">
          {!hideCity && (
            <div className="stay-search-main__fields__col1">
              <input
                placeholder="Where from"
                disabled={disableCity}
                value={
                  state.selectedHotel?.hotel_name || state?.destinationCity
                }
                onClick={() => handleOpenSheet("city")}
                onChange={(e) => {
                  props.searchDestinations(e);
                }}
              />
              {props.cityError && (
                <div className="errorText">
                  <ErrorIcon color="#fff" />
                  From is required
                </div>
              )}
              {state?.tempHotelList?.length > 0 && !isMobile && (
                <div className="stay-search-main__fields__col1__results">
                  {state.tempHotelList.map((item, index) => (
                    <div
                      className={`stay-search-main__fields__col1__results__row ${
                        index !== state.tempHotelList?.length - 1 &&
                        "stay-search-main__fields__col1__results__row__mb"
                      }`}
                      onClick={() =>
                        props.setState({
                          ...state,
                          destinationCity: item.city_name,
                          destinationCountry: item.country_name,
                          selectedHotel: item?.hotel_name ? item : {},
                          tempHotelList: [],
                        })
                      }
                    >
                      <div className="stay-search-main__fields__col1__results__row__col1">
                        <img
                          src={item.thumbnail || item.thumbnail_image}
                          alt="thumbnail"
                        />
                      </div>
                      <div className="stay-search-main__fields__col1__results__row__col2">
                        <div className="stay-search-main__fields__col1__results__row__col2__txt1">
                          {item.hotel_name || item.city_name}
                        </div>
                        <div className="stay-search-main__fields__col1__results__row__col2__txt2">
                          {item.country_name}
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* <div className="stay-search-main__fields__col1__results__row">
              <div className="stay-search-main__fields__col1__results__row__col1">
                <img src="https://product-image.globaltix.com/uat-gtImage/e46f7539-c31c-4023-aac3-5d3b18ba8b5b" />
              </div>
              <div className="stay-search-main__fields__col1__results__row__col2">
                <div className="stay-search-main__fields__col1__results__row__col2__txt1">
                  Amaris hotel, bali
                </div>
                <div className="stay-search-main__fields__col1__results__row__col2__txt2">
                  Bali and Location Details
                </div>
              </div>
            </div>
            <div className="stay-search-main__fields__col1__results__row">
              <div className="stay-search-main__fields__col1__results__row__col1">
                <div className="stay-search-main__fields__col1__results__row__col1__box">
                  <img src={locationImg} />
                </div>
              </div>
              <div className="stay-search-main__fields__col1__results__row__col2">
                <div className="stay-search-main__fields__col1__results__row__col2__txt1">
                  Bali
                </div>
                <div className="stay-search-main__fields__col1__results__row__col2__txt2">
                  123+ Stays
                </div>
              </div>
            </div> */}
                </div>
              )}
            </div>
          )}
          {!showOnlyCity && (
            <>
              <div className="stay-search-main__fields__col2">
                <CalendarIcon />
                <input
                  placeholder="Check-in date"
                  value={
                    state?.start_date
                      ? moment(state.start_date).format("DD MMM,YYYY")
                      : null
                  }
                  onClick={() => {
                    if (isMobile) {
                      setShowSearchSheet("checkin");
                    } else {
                      setOpenCheckin(!openCheckin);
                    }
                  }}
                />
                {openCheckin && (
                  <div className="dateMain" ref={dropdownRef}>
                    <Calendar
                      onChange={(range) => {
                        setOpenCheckin(false);
                        setOpenCheckout(true);
                        props.setState({ ...state, start_date: range });
                      }}
                      minDate={new Date()}
                      date={state.start_date}
                      months={state.isMobile ? 1 : 1}
                      preventSnapRefocus={true}
                      direction="horizontal"
                    />
                  </div>
                )}
              </div>
              <div className="stay-search-main__fields__col3">
                <CalendarIcon />
                <input
                  placeholder="Check-out date"
                  value={
                    state?.end_date
                      ? moment(state.end_date).format("DD MMM,YYYY")
                      : null
                  }
                  onClick={() => {
                    if (isMobile) {
                      setShowSearchSheet("checkout");
                    } else {
                      setOpenCheckout(!openCheckout);
                    }
                  }}
                />
                {openCheckout && (
                  <div className="dateMain" ref={dropdownRef}>
                    <Calendar
                      onChange={(range) => {
                        setOpenCheckout(false);
                        setOpenPassenger(true);
                        props.setState({ ...state, end_date: range });
                      }}
                      minDate={new Date(state.start_date)}
                      date={state.end_date}
                      months={state.isMobile ? 1 : 1}
                      preventSnapRefocus={true}
                      direction="horizontal"
                    />
                  </div>
                )}
              </div>
              <div className="stay-search-main__fields__col4">
                <img src={userImg} alt="" />
                <input
                  placeholder="Guests & Rooms"
                  value={`${state?.room_count} Room`}
                  onClick={() => {
                    if (isMobile) {
                      setShowSearchSheet("passenger");
                    } else {
                      setOpenPassenger(!openPassenger);
                    }
                  }}
                />
                {openPassenger && (
                  <div
                    className="stay-search-main__fields__col4__results"
                    ref={dropdownRef}
                  >
                    <PassengerSelection
                      state={state}
                      onClose={() => setOpenPassenger(!openPassenger)}
                      setState={props.setState}
                      applyQty={props.applyQty}
                      onChangeChildAge={[1, 2, 3]}
                    />
                  </div>
                )}
              </div>
              <div className="stay-search-main__fields__col5">
                <Button
                  endIcon={<SearchIcon />}
                  className="stay-search-main__fields__col5__searchBtn"
                  // onSubmit={() => props.searchHotels()}
                  onClick={() => {
                    props.searchHotels();
                    props.showBottomSheet && props.setShowBottomSheet(false);
                  }}
                >
                  Search
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      <BottomSearchSheet
        setState={props.setState}
        show={showSearchSheet}
        searchDestinations={props.searchDestinations}
        state={state}
        openCheckin={openCheckin}
        setShowSearchSheet={setShowSearchSheet}
      />
      {showBottomSheet && (
        <BottomSearchSheetForList
          state={state}
          className={"list-bottom-search-sheet"}
          showBottomSheet={showBottomSheet}
          setShowBottomSheet={setShowBottomSheet}
          show={showBottomSheet}
          setState={props.setState}
          searchHotels={props.searchHotels}
          searchDestinations={props.searchDestinations}
          cityError={props.cityError}
          showOnlyCity={true}
        />
      )}
    </>
  );
};

export default SearchComponent;
